import React from "react";
import EqualCardHeight from "../../utilities/EqualCardHeight";
import Render from "../../utilities/Render";

class LandingPage extends React.Component {
  constructor(props) {
    super();
  }

  render() {
    return (
      <div className="container" id="landing-page">
        <div className="row">
          {this.props.data.map((item, index) => (
            <div
              key={"card-" + index}
              className="col-sm-6 col-lg-4 align-items-stretch card-container d-flex align-items-stretch"
            >
              <div className="card">
                <div className="card-body ">
                  <div
                    className="col-12   image-container"
                    style={{ backgroundImage: "url(" + item.imageURL + ")" }}
                  >
                    <a href={item.targetURL} className="stretched-link"></a>
                  </div>
                  <div className="col-12 ">
                    <div className={"text-content  " + item.colour}>
                      <a href={item.targetURL} className="stretched-link">
                        <h2>{item.title}</h2>
                        <p> {item.description}</p>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default LandingPage;

Render.Component("#landing-page-react", landingPageData, LandingPage);
